@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../constants/spacing.module.less';

.products-tab {
  padding: @space-24;
}

.tab-header {
  padding-bottom: @space-24;
}

.products-card {
  padding: @space-24;
  margin-bottom: @space-24;

  &:last-child {
    margin-bottom: 0;
  }
}

.card-title {
  color: var(--grey-900);
  margin-bottom: @space-4;
}

.card-description {
  color: var(--grey-700);
  margin-bottom: @space-8;
}

.divider {
  border-color: var(--grey-300);
}
